import React from 'react';
import {
	StyledEngineProvider,
	Theme,
	ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import { GlobalStyle } from '../ApplicationWrapper.styles';
import WeaveThemeProvider from './WeaveContext/WeaveThemeProvider';
import { createGenerateClassName } from '@mui/styles';
import useDefaultTheme from './themes/useDefaultTheme';
import StylesProvider from '@mui/styles/StylesProvider';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { INFO360_THEMES } from './theme.types';

type MaterialProvidersProps = {
	children: React.ReactNode | React.ReactNode[] | string;
	defaultTheme?: INFO360_THEMES;
	theme?: Theme;
};

interface ThemeStylesProviderProps {
	children: React.ReactNode | React.ReactNode[] | string;
	defaultTheme?: INFO360_THEMES;
	theme?: Theme;
}

//Material UI and Styled Components Providers
const MaterialProviders = ({
	children,
	theme,
	defaultTheme,
}: MaterialProvidersProps) => {
	const generateClassName = createGenerateClassName({
		productionPrefix: 'inno',
	});

	const weaveTheme = useDefaultTheme({ defaultTheme });
	const selectedTheme = theme ?? weaveTheme;

	return (
		<StylesProvider injectFirst generateClassName={generateClassName}>
			<StyledEngineProvider injectFirst>
				<MuiThemeProvider theme={selectedTheme}>
					<StyledComponentsThemeProvider theme={selectedTheme}>
						{children}
					</StyledComponentsThemeProvider>
				</MuiThemeProvider>
			</StyledEngineProvider>
		</StylesProvider>
	);
};

export const ThemeStylesProvider = ({
	children,
	defaultTheme = INFO360_THEMES.Classic,
	theme,
}: ThemeStylesProviderProps) => {
	return (
		<WeaveThemeProvider defaultTheme={defaultTheme}>
			<MaterialProviders theme={theme} defaultTheme={defaultTheme}>
				<GlobalStyle />
				{children}
			</MaterialProviders>
		</WeaveThemeProvider>
	);
};
